
(function (window, document, $) {
  'use strict';
  if (!$) return;

  function formatPrice(cents) {
    if (cents == null) return '$0';
    const raw = (cents / 100).toFixed(2);
    return `$${raw.replace('.00', '')}`;
  }

  function parseProductJSON($root) {
    const $jsonEl = $root.find('script.js-product-data[type="application/json"]').first();
    const raw = $jsonEl.length ? $jsonEl.html() : ($root.find('script[type="application/json"]').first().html() || '');
    try { return raw ? JSON.parse(raw) : null; }
    catch (e) { console.warn('[AddonProduct] Bad JSON', e); return null; }
  }

  function getSelectedVariant($root, productData) {
    if (!productData || !Array.isArray(productData.variants)) return null;
    const $options = $root.find('.js-product-option-radio-alt:checked, .js-product-option-list');
    if (!$options.length) return productData.variants.length === 1 ? productData.variants[0] : null;

    let match = null;
    productData.variants.forEach(function (v) {
      var selected = true;
      $options.each(function () {
        var $opt = $(this);
        var idx = $opt.data('index'); // "option1", "option2"...
        var val = $opt.val();
        if (v[idx] !== val) selected = false;
      });
      if (selected) match = v;
    });
    return match;
  }

  function updateTitle($root, variant) {
    var $label = $root.find('.js-grid-product-variant-title-alt');
    if ($label.length) $label.text((variant && variant.title) || '');

    var $subtitle = $root.find('.js-variant-subtitle-alt');
    if ($subtitle.length) {
      var sub = (window._supertheme && window._supertheme._variants && variant && window._supertheme._variants[variant.id] && window._supertheme._variants[variant.id].subtitle) || '';
      if (sub) $subtitle.text(sub).removeClass('hidden');
      else $subtitle.text('').addClass('hidden');
    }
  }

  function updatePrice($root, variant) {
    var $price = $root.find('.js-product-price-alt');
    var $compare = $root.find('.js-product-compare-at-price-alt');
    if ($price.length) $price.text(formatPrice((variant && variant.price) || 0));

    var compareAt = variant && variant.compare_at_price;
    if ($compare.length) {
      if (compareAt && compareAt > ((variant && variant.price) || 0)) {
        $compare.text(formatPrice(compareAt)).removeClass('hidden');
      } else {
        $compare.text('').addClass('hidden');
      }
    }
  }

  function updateImage($root, variant) {
    var $img = $root.find('.js-grid-product-image');
    if (!$img.length || !variant) return;

    var id = variant.id;
    var url = $img.data('image-' + id) || $img.data('image-default');
    if (!url) return;

    if ($img[0].nodeName === 'IMG') $img[0].src = url;
    else $img.css({ backgroundImage: 'url(' + url + ')' });
  }

  function updateHiddenSelect($root, variant) {
    var $select = $root.find('.js-product-variant-select-alt');
    if ($select.length && variant && variant.id) $select.val(String(variant.id));
  }

  function updateAttrs($root, variant) {
    if (!variant) return;
    $root.attr('data-variant', String(variant.id));
    $root.attr('data-price', String(((variant.price || 0) / 100)));
  }

  function sync($root, productData) {
    var variant = getSelectedVariant($root, productData);
    if (!variant) return;

    updateTitle($root, variant);
    updatePrice($root, variant);
    updateImage($root, variant);
    updateHiddenSelect($root, variant);
    updateAttrs($root, variant);

    // IMPORTANT: do not bubble to the document; use triggerHandler
    $root.triggerHandler({
      type: 'variantChange',
      variant: variant,
      product: productData,
      scope: 'alt'
    });
  }

  function mount(rootEl) {
    var $root = rootEl && rootEl.jquery ? rootEl : $(rootEl);
    if (!$root.length) return;
    var productData = parseProductJSON($root);

    // Bind within this root only
    $root.on('change', '.js-product-option-radio-alt', function () {
      sync($root, productData);
    });

    // Initial sync
    sync($root, productData);
  }

  function init(context) {
    var $ctx = context && context.jquery ? context : $(context || document);
    $ctx.find('.js-product-wrapper-alt').each(function () { mount($(this)); });
  }

  // Auto-init on DOM ready
  $(function () { init(document); });

  // Also support Shopify section load events if present
  $(document).on('shopify:section:load shopify:section:select', function (e) {
    if (e && e.target) init(e.target);
  });

  // Expose minimal API if needed
  window.SaieAddonProduct = { init: init, mount: mount };
})(window, document, window.jQuery);

(function (window, document, $) {
  'use strict';
  if (!$) return;

  let lockUntil = 0;
  function now() { return Date.now ? Date.now() : new Date().getTime(); }

  function readVariantId($alt) {
    const id = String($alt.find('.js-product-variant-select-alt').val() || '');
    return id || null;
  }

  function isChecked($alt) {
    const $cb = $alt.find('#rs-addon-check');
    return $cb.length && $cb.is(':checked');
  }

function safeAddAddon(variantId, $alt) {
  const payload = {
    id: Number(variantId),
    quantity: 1,
    properties: { _addon: true, _addon_source: 'vanity_case' }
  };

  // Use a tiny debounce so we only refresh/open once, even if the parent ATC
  // and addon add both fire close together.
  const usingCartLoader = typeof CartLoader === 'function';
  const REFRESH_DELAY_MS = usingCartLoader ? 450 : 0;

  const requestRefresh = function () {
    if (window.__addonRefreshTimer) return;
    window.__addonRefreshTimer = setTimeout(function () {
      window.__addonRefreshTimer = null;

      // Tell Cart to re-render and open the drawer
      $(document).trigger({
        type: 'cartRefresh',
        openDrawer: true,
        enableAutoGwp: true  // keep GWP logic active
      });
    }, REFRESH_DELAY_MS);
  };

  try {
    if (usingCartLoader) {
      // Your site’s standard add; no success callback exposed, so we just nudge later.
      new CartLoader({ payload: payload });
      requestRefresh();
    } else if (window.CartJS && typeof window.CartJS.addItem === 'function') {
      // If CartJS is available, use it and refresh on success.
      window.CartJS.addItem(payload.id, payload.quantity, payload.properties, {
        success: function () { requestRefresh(); },
        error: function (err) { console.warn('[Addon] CartJS.addItem failed', err); }
      });
    } else {
      // Fallback: Shopify AJAX API
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: payload,
        success: function () { requestRefresh(); },
        error: function (xhr) { console.warn('[Addon] /cart/add.js failed', xhr && xhr.responseText); }
      });
    }
  } catch (err) {
    console.warn('[Addon] add addon failed', err);
  } finally {
    // avoid re-adding on the next click
     try {
      Shopify.analytics.publish('addon_selected');
    } catch {}

    $alt.find('#rs-addon-check').prop('checked', false);
  }
}


  function queueAddonAdd($pdp) {
    try {
      const $alt = $pdp.find('.js-product-wrapper-alt');
      if (!$alt.length) return;

      if (!isChecked($alt)) return;

      const variantId = readVariantId($alt);
      if (!variantId) return;

      // Optional availability check from embedded JSON
      try {
        const raw = $alt.find('script.js-product-data[type="application/json"]').first().html() || '';
        const data = raw ? JSON.parse(raw) : null;
        const v = data && Array.isArray(data.variants) ? data.variants.find(x => String(x.id) === variantId) : null;
        if (v && v.hasOwnProperty('available') && !v.available) return;
      } catch (_) {}

      const t = now();
      if (t < lockUntil) return;
      lockUntil = t + 800;

      // Fire after the main add handler has run
      setTimeout(() => safeAddAddon(variantId, $alt), 650);
    } catch (e) {
      console.warn('[Addon] queueAddonAdd error', e);
    }
  }

  // Listen for main ATC interactions (no preventDefault, no stopPropagation)
  $(document).on(
    'click',
    '.js-add-to-cart, .js-add-to-cart-alias, .js-add-to-cart-bundle, .js-add-to-cart-duo',
    function (e) {
      const $pdp = $(e.currentTarget).closest('.js-pdp');
      if (!$pdp.length) return;
      try {
        if (window.requestAnimationFrame) {
          requestAnimationFrame(() => setTimeout(() => queueAddonAdd($pdp), 0));
        } else {
          setTimeout(() => queueAddonAdd($pdp), 0);
        }
      } catch {
        setTimeout(() => queueAddonAdd($pdp), 0);
      }
    }
  );
})(window, document, window.jQuery);
